import { getAuth, signInWithCustomToken, signOut } from 'firebase/auth';
import { firebaseApp } from 'firebaseConfig';
import { apiGenerated as api } from './apiGenerated';

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [],
  endpoints: {
    getFirebaseTokenV1UserFirebaseTokenGet: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          await signInWithCustomToken(getAuth(firebaseApp), data.token);
        } catch {
          signOut(getAuth(firebaseApp));
        }
      },
    },
  },
});

export { enhancedApi as api };

export const { useGetFirebaseTokenV1UserFirebaseTokenGetQuery, useGetUserIdV1UserGetQuery } = enhancedApi;
